import { useContext } from "react";
import { BrandContext } from "../context";

/** The brand context. */
export const useBrandContext = () => useContext(BrandContext);
